import breakpointComponentMapper from "../utils/breakpointComponentMapper"

const deviceMixins = component => ({
  computed: {
    dynamicComponent() {
      return breakpointComponentMapper[this.$vuetify.breakpoint.name][component];
    }
  }
})

export default deviceMixins